import React from "react";
import ClipLoader from "react-spinners/ClipLoader";
import { formatDateWithZone, trimAddress } from "../helper/functions";

export default function TransactionTable({ dexData, loading, stats, page, setPage, setLoading }) {
  const override = {
    display: "block",
    position: "absolute",
    top: "60%",
    left: "50%",
  };

  return (
    <div className="col-lg-12 ">
      <div className="card">
        <div className="card-header">
          <h4 className="card-title">Recent Transactions</h4>
        </div>
        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-bordered table-striped verticle-middle table-responsive-sm bg-transpant">
              <thead>
                <tr className="bg-transparent">
                  <th scope="col">TRANSACTION HASH</th>
                  <th scope="col">TIMESTAMP</th>
                  <th scope="col">ACTION</th>
                  <th scope="col">PRICE (USD)</th>
                  <th scope="col" className="text-end">
                    TOKEN AMOUNT
                  </th>
                  <th scope="col" className="text-end">
                    TOTAL VALUE (USD)
                  </th>
                  <th scope="col" className="text-end"></th>
                </tr>
              </thead>
              <tbody>
                {!loading ? (
                  dexData && dexData.length > 0 ? (
                    dexData.map((rowdata, index) => {
                      return (
                        <tr className="bg-transparent">
                          <td className="bg-transparent">
                            <a target="_balnk" href={`https://etherscan.io/tx/${rowdata.transaction.hash ? rowdata.transaction.hash : ""}`}>
                              {trimAddress(rowdata.transaction.hash ? rowdata.transaction.hash : "")}
                            </a>
                          </td>
                          <td className="bg-transparent">{rowdata.block.timestamp.time ? formatDateWithZone(rowdata.block.timestamp.time) : " - "}</td>
                          <td className="bg-transparent">
                            {rowdata.buyCurrency.symbol ? (
                              rowdata.buyCurrency.symbol === "FIND" ? (
                                <>
                                  SELL <i className="fas fa-level-down-alt ms-2 text-danger m-l-10"></i>
                                </>
                              ) : (
                                <>
                                  BUY <i className="fas fa-level-up-alt ms-2 text-success m-l-10"></i>
                                </>
                              )
                            ) : (
                              "-"
                            )}
                          </td>
                          <td className="bg-transparent">${stats && stats.barc_price ? parseFloat(stats.barc_price).toFixed(2) : "0.00"}</td>
                          <td className="bg-transparent">{rowdata.buyCurrency.symbol ? (rowdata.buyCurrency.symbol === "FIND" ? parseFloat(rowdata.buyAmount).toFixed(3) : parseFloat(rowdata.sellAmount).toFixed(3)) : "-"} FIND</td>
                          <td className="bg-transparent">
                            $
                            {stats &&
                              stats.barc_price &&
                              (rowdata.buyCurrency.symbol ? (rowdata.buyCurrency.symbol === "FIND" ? parseFloat(rowdata.buyAmount * stats.barc_price).toFixed(3) : parseFloat(rowdata.sellAmount * stats.barc_price).toFixed(3)) : "-")}
                          </td>
                          <td className="bg-transparent text-end">
                            <span>
                              <a target="_balnk" href={`https://etherscan.io/tx/${rowdata.transaction.hash ? rowdata.transaction.hash : ""}`}>
                                <i className="fa fa-arrow-up-right-from-square color-muted"></i>
                              </a>
                            </span>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr className="border-bottom odd bg-transparent">
                      <td className="bg-transparent text-center" colSpan={6}>
                        No record Found
                      </td>
                    </tr>
                  )
                ) : (
                  <tr className="text-center bg-transparent">
                    <td className="bg-transparent" colspan="6" height={300}>
                      <ClipLoader
                        color="#fff"
                        loading={true}
                        cssOverride={override}
                        size={50}
                        // className="spinner"
                      />
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            <div className="col-12">
              <div className="dataTables_paginate paging_simple_numbers d-flex justify-content-end" id="example1_paginate">
                <ul className="pagination">
                  {page > 0 && (
                    <li className="paginate_button page-item previous">
                      <a
                        href="#sec"
                        className="btn btn-primary mx-2"
                        onClick={() => {
                          setPage(page > 10 ? page - 10 : 0);
                          setLoading(true);
                        }}
                      >
                        Previous
                      </a>
                    </li>
                  )}
                  {dexData && dexData.length > 9 && (
                    <li className="paginate_button page-item next">
                      <a
                        href="#sec"
                        className="btn btn-primary"
                        onClick={() => {
                          setPage(page + 10);
                          setLoading(true);
                        }}
                      >
                        Next
                      </a>
                    </li>
                  )}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
